/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning': {
    width: 11,
    height: 10,
    viewBox: '0 0 11 10',
    data: '<path pid="0" d="M5.433 10.015a4.938 4.938 0 1 1 0-9.875 4.938 4.938 0 0 1 0 9.875zm-.15-4.085h.618l.316-2.982-1.25-.007.317 2.99zm-.259.448v.835H6.16v-.835H5.024z" _fill="#FF8E8A" fill-rule="evenodd"/>'
  }
})
